// Import our CSS
import "@/scss/swiper.scss";

import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";

window.Swiper = Swiper;

let sliders = document.querySelectorAll(".swiper-slider");
sliders.forEach((slider) => {
    let settings = {};
    let modules = { modules: [] };

    settings["modules"] = [];
    if (slider.dataset.modulenav) {
        modules["modules"].push(Navigation);
    }

    if (slider.dataset.modulepagination) {
        modules["modules"].push(Pagination);
    }

    if (slider.dataset.moduleautoplay) {
        modules["modules"].push(Autoplay);
    }

    if (slider.dataset.moduleeffect) {
        modules["modules"].push(EffectFade);
    }

    if (slider.dataset.settings) {
        settings = JSON.parse(slider.dataset.settings);
    }

    settings = merge(modules, settings);
    let swiper = new Swiper(slider, settings);
});

function merge(modules, settings) {
    for (var key in settings) {
        if (settings.hasOwnProperty(key)) modules[key] = settings[key];
    }
    return modules;
}


document.addEventListener("DOMContentLoaded", function () {
    let swiperEl = document.querySelector(".swiper-slider");

    if (swiperEl && swiperEl.swiper) {
        let settings = JSON.parse(swiperEl.getAttribute("data-settings"));

        if (settings.autoplay && settings.autoplay.pauseOnMouseEnter) {
            
            swiperEl.addEventListener("mouseenter", function () {
                swiperEl.swiper.autoplay.stop();
            });

            swiperEl.addEventListener("mouseleave", function () {
                swiperEl.swiper.autoplay.start();
            });

            swiperEl.addEventListener("focusin", function () {
                swiperEl.swiper.autoplay.stop();
            });

            swiperEl.addEventListener("focusout", function () {
                swiperEl.swiper.autoplay.start();
            });
        }
    }
});
